import React, {Component} from 'react';
import Modal from 'react-responsive-modal';

class ModalWindow extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: this.props.open,
        };


    }

    onOpenModal = () => {
        //this.setState({ open: true });
    };

    onCloseModal = (mode, next) => {
        this.setState({ open: false });
        if(mode === true)
        {
            next();
        } else {
            this.props.onCancel();
        }
    };

    componentDidUpdate(prevProps) {
        if(this.props.open && !this.state.open) {
            this.setState({open: this.props.open })
        }
    }

    render() {
        return (
            <Modal open={this.state.open} onClose={this.onCloseModal} >
            <div className="modal-header">
                <h5 className="modal-title f-w-600" id="exampleModalLabel2">
                    {this.props.title}
                </h5>
            </div>
            <div className="modal-body">
                {this.props.content}
                {this.props.children}
            </div>
            <div className="modal-footer">
                {this.props.commands.map(command => 
                    <button type="button" className="btn btn-primary" onClick={() => this.onCloseModal(true,command.handler)}>{command.title}</button>
                )}
                <button type="button" className="btn btn-secondary" onClick={() => this.onCloseModal(false)}>Cancel</button>
            </div>
        </Modal>    
        )
    }
}
export default ModalWindow;